export const IMAGE_API = "https://cuisinecrafters.net/vimeo-upload";
export const VIMEO_HANDLER = "https://cuisinecrafters.net/vimeo-upload";
export const DOCUMENT_UPLOAD = "https://cuisinecrafters.net/document-upload";

export const CHAT_API = {
  LOGIN: "login",
  AUTHORIZED: "authorized",
  SOCKET_UPDATE: "update-socket",
  SEND: "send-message",
  NEW_MESSAGE_RECEIVED: "new-message",
  DELIVERING: "update-delivered",
  DELIVERED: "message-delivered",
  TYPING: "typing",
  TYPING_STOP: "typing-stopped",
  MESSAGE_LIST_ALL: "fetch-old-all",
  MESSAGE_LIST_ALL_SUCCESS: "old-chat-list",
  MESSAGE_LIST_NEW: "fetch-new-messages",
  MESSAGE_LIST_NEW_SUCCESS: "list-new-messages",
  UNREAD_COUNT: "fetch-unread-count",
  UNREAD_COUNT_SUCCESS: "unread-count",
  UNREAD_COUNT_ALL: "fetch-unread-count-all",
  UNREAD_COUNT_SUCCESS_ALL: "unread-count-all"
};
export const DISH_TYPES = [
  {
    name: "VEGAN",
    display: "VEGAN",
    initials: "V"
  },
  {
    name: "MEAT",
    display: "MEAT",
    initials: "M"
  },
  {
    name: "NOMEAT",
    display: "NO MEAT",
    initials: "NM"
  },
  {
    name: "KOSHER",
    display: "KOSHER",
    initials: "K"
  },
  {
    name: "ORGANIC",
    display: "ORGANIC",
    initials: "O"
  },
  {
    name: "HALAL",
    display: "HALAL",
    initials: "H"
  },
  {
    name: "PALEO",
    display: "PALEO",
    initials: "P"
  },
  {
    name: "KETO",
    display: "KETO",
    initials: "KE"
  },
  {
    name: "GLUTEN_FREE",
    display: "GLUTEN FREE",
    initials: "GF"
  },
  {
    name: "SOY_FREE",
    display: "SOY FREE",
    initials: "SF"
  },
  {
    name: "NUT_FREE",
    display: "NUT FREE",
    initials: "NF"
  },
  {
    name: "DAIRY_FREE",
    display: "DAIRY FREE",
    initials: "DF"
  }
];

export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const mobileRegex = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})$/;

export const BOOKING_STATUS = {
  INCOMPLETE: "INCOMPLETE",
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  CANCELED: "CANCELED",
  CANCELED_BY_DINER: "CANCELED_BY_DINER",
  CANCELED_BY_CHEF: "CANCELED_BY_CHEF",
  COMPLETED: "COMPLETED",
  COMPLETED_BY_CHEF: "COMPLETED_BY_CHEF",
  COMPLETED_BY_USER: "COMPLETED_BY_USER",
  EXPIRED: "EXPIRED",
  CANCELED_APPROVED_BY_CHEF: "CANCELED_APPROVED_BY_CHEF",
  CANCELED_APPROVED_BY_DINER: "CANCELED_APPROVED_BY_DINER"
};

export const GA_CODE = 'UA-227477399-1';

export const addressValidationAPI = 'https://addressvalidation.googleapis.com/v1:validateAddress?key=AIzaSyCZJaZ2oDYvkNgnUva2rh6ep2fhkrZXV00';

export const stateList = [
  {
    name: 'Alabama',
    id: 'AL'
  },
  {
    name: 'Alaska',
    id: 'AK'
  },
  {
    name: 'American Samoa',
    id: 'AS'
  },
  {
    name: 'Arizona',
    id: 'AZ'
  },
  {
    name: 'Arkansas',
    id: 'AR'
  },
  {
    name: 'California',
    id: 'CA'
  },
  {
    name: 'Colorado',
    id: 'CO'
  },
  {
    name: 'Connecticut',
    id: 'CT'
  },
  {
    name: 'Delaware',
    id: 'DE'
  },
  {
    name: 'District of Columbia',
    id: 'DC'
  },
  {
    name: 'Federated States of Micronesia',
    id: 'FM'
  },
  {
    name: 'Florida',
    id: 'FL'
  },
  {
    name: 'Georgia',
    id: 'GA'
  },
  {
    name: 'Guam',
    id: 'GU'
  },
  {
    name: 'Hawaii',
    id: 'HI'
  },
  {
    name: 'Idaho',
    id: 'ID'
  },
  {
    name: 'Illinois',
    id: 'IL'
  },
  {
    name: 'Indiana',
    id: 'IA'
  },
  {
    name: 'Iowa',
    id: 'IO'
  },
  {
    name: 'Kansas',
    id: 'KS'
  },
  {
    name: 'Kentucky',
    id: 'KY'
  },
  {
    name: 'Louisiana',
    id: 'LA'
  },
  {
    name: 'Maine',
    id: 'ME'
  },
  {
    name: 'Marshall Islands',
    id: 'MH'
  },
  {
    name: 'Maryland',
    id: 'MD'
  },
  {
    name: 'Massachusetts',
    id: 'MA'
  },
  {
    name: 'Michigan',
    id: 'MI'
  },
  {
    name: 'Minnesota',
    id: 'MN'
  },
  {
    name: 'Mississippi',
    id: 'MS'
  },
  {
    name: 'Missouri',
    id: 'MO'
  },
  {
    name: 'Montana',
    id: 'MT'
  },
  {
    name: 'Nebraska',
    id: 'NE'
  },
  {
    name: 'Nevada',
    id: 'NV'
  },
  {
    name: 'New Hampshire',
    id: 'NH'
  },
  {
    name: 'New Jersey',
    id: 'NJ'
  },
  {
    name: 'New Mexico',
    id: 'NM'
  },
  {
    name: 'New York',
    id: 'NY'
  },
  {
    name: 'North Carolina',
    id: 'NC'
  },
  {
    name: 'North Dakota',
    id: 'ND'
  },
  {
    name: 'Northern Mariana Islands',
    id: 'MP'
  },
  {
    name: 'Ohio',
    id: 'OH'
  },
  {
    name: 'Oklahama',
    id: 'OK'
  },
  {
    name: 'Oregon',
    id: 'OR'
  },
  {
    name: 'Palua',
    id: 'PW'
  },
  {
    name: 'Pennsylvania',
    id: 'PA'
  },
  {
    name: 'Puerto Rico',
    id: 'PR'
  },
  {
    name: 'Rhode Island',
    id: 'RI'
  },
  {
    name: 'South Carolina',
    id: 'SC'
  },
  {
    name: 'South Dakota',
    id: 'SD'
  },
  {
    name: 'Tennessee',
    id: 'TN'
  },
  {
    name: 'Texas',
    id: 'TX'
  },
  {
    name: 'Utah',
    id: 'UT'
  },
  {
    name: 'Vermont',
    id: 'VT'
  },
  {
    name: 'Virgin Islands',
    id: 'VI'
  },
  {
    name: 'Virginia',
    id: 'VA'
  },
  {
    name: 'Washington',
    id: 'WA'
  },
  {
    name: 'West Virginia',
    id: 'WV'
  },
  {
    name: 'Wisconsin',
    id: 'WI'
  },
  {
    name: 'Wyoming',
    id: 'WY'
  },
];
